export const CONTRIBUTION_AFTER_RESULTS = "after_game2_results";
export const CONTRIBUTION_AFTER_CHATBOT = "after_chatbot";
export const CONTRIBUTION_AFTER_NEGOTIATION = "after_negotiation";

const CONTRIBUTION_TIMINGS = [
  CONTRIBUTION_AFTER_RESULTS,
  CONTRIBUTION_AFTER_CHATBOT,
  CONTRIBUTION_AFTER_NEGOTIATION,
];

export function assignContributionTiming(player, random = Math.random) {
  const existing = player.get("stage2ContributionTiming");
  if (CONTRIBUTION_TIMINGS.includes(existing)) {
    return existing;
  }
  const timing = CONTRIBUTION_TIMINGS[Math.floor(random() * CONTRIBUTION_TIMINGS.length)];
  player.set("stage2ContributionTiming", timing);
  return timing;
}

export function getContributionAssessment(player, timing) {
  if (timing === CONTRIBUTION_AFTER_NEGOTIATION) {
    const finalAssessment = player.get("stage2ContributionAfterNegotiationAssessment");
    if (finalAssessment) return finalAssessment;
  }
  const firstAssessment = player.get("stage2ContributionAssessment");
  const firstTiming = firstAssessment?.timing ?? player.get("stage2ContributionTiming");
  return firstTiming === timing ? firstAssessment : undefined;
}

export function saveContributionAssessment(player, assessment) {
  if (getContributionAssessment(player, assessment.timing)) return;
  // Preserve the first response for existing exports and analyses.
  if (!player.get("stage2ContributionAssessment")) {
    player.set("stage2ContributionAssessment", assessment);
  }
  if (assessment.timing === CONTRIBUTION_AFTER_NEGOTIATION) {
    player.set("stage2ContributionAfterNegotiationAssessment", assessment);
  }
}

export function shouldAskContribution(player, timing) {
  const scheduled = timing === CONTRIBUTION_AFTER_NEGOTIATION ||
    player.get("stage2ContributionTiming") === timing;
  return CONTRIBUTION_TIMINGS.includes(timing) && scheduled &&
    !getContributionAssessment(player, timing);
}

// Work in cents so the entered amount and the chart always sum to the pot.
export function contributionEstimate(value, totalDollars) {
  const text = String(value ?? "").trim();
  const total = Number(totalDollars);
  if (!/^(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/.test(text) ||
      !Number.isFinite(total) || total < 0) {
    return null;
  }
  const totalCents = Math.round(total * 100);
  const amountCents = Math.round(Number(text) * 100);
  if (!Number.isSafeInteger(amountCents) || amountCents > totalCents) {
    return null;
  }
  return {
    amountDollars: amountCents / 100,
    partnerAmountDollars: (totalCents - amountCents) / 100,
    totalDollars: totalCents / 100,
    percent: totalCents > 0 ? amountCents / totalCents * 100 : null,
  };
}
